import type { Step } from "react-joyride";

export const otRequestListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຄຳຂໍ OT ຂອງທ່ານ. ເບິ່ງລາຍການຄຳຂໍທີ່ສົ່ງ ແລະ ສະຖານະ (ລໍຖ້າອະນຸມັດ / ອະນຸມັດແລ້ວ / ປະຕິເສດ).",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="ot-request-list-toolbar"]',
    content:
      "ສ້າງຄຳຂໍ OT ໃໝ່, ສົ່ງອອກເປັນ CSV ຫຼື ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-request-list-summary"]',
    content: "ສະຫຼຸບ: ຊົ່ວໂມງອະນຸມັດແລ້ວ, ຄຳຂໍລໍຖ້າ ແລະ ວັນທີຖອດຖອກຕໍ່ໄປ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-request-list-filter"]',
    content: "ກັ່ນຕອງຕາມສະຖານະ ແລະ ຄົ້ນຫາ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-request-list-table"]',
    content:
      "ຕາຕະລາງຄຳຂໍ OT. ກົດແຖວເພື່ອເບິ່ງລາຍລະອຽດ ຫຼື ແກ້ໄຂ (ຖ້າຍັງລໍຖ້າອະນຸມັດ).",
    placement: "top",
  },
];
